export default __webpack_public_path__ + "static/media/LabManagement.a8f96dbf.svg";